import './TokenExpiredPopUp.css'

const TokenExpiredPopUp = () => {
    return (
        <div className='Token-expired-pop-up'>
            <h4>Aucune donnée n'a été trouvée</h4>
            <p>Veuillez rafraîchir la page.</p>
            <p>Si cette page est ouverte dans un nouvel onglet, fermez-le et rouvrez-en un après avoir rafraîchi la page LumApps.</p>
            <p>Si le problème persiste veuillez vous rapprochez du support magasins en écrivant à l'adresse :</p>
            <a href="mailto:support_magasins@groupe-joueclub.fr">support_magasins@groupe-joueclub.fr</a>
            <p> en indiquant le ou les magasins que vous souhaitez associer à votre compte ainsi que les adresses emails des comptes concernés.</p>
        </div>
    );
}

export default TokenExpiredPopUp;